import { useSelector } from 'react-redux';

// eslint-disable-next-line import/prefer-default-export
export const useRoleAccess = () => {
  const roles = useSelector((state) => state.auth.djangoRoles);
  const entity = roles?.entity || [];
  const hasEntity = (ent) => entity.includes(ent);
  const hasCategory = (cat) => roles?.categories?.includes(cat);
  const hasSubCategory = (subCat) => roles?.subCategories?.includes(subCat);
  const hasPageAccess = (pageAccess) => roles?.pages?.includes(pageAccess);
  // console.log("hasPageAccess----------:",hasPageAccess)

  return { entity, hasCategory, hasSubCategory, hasEntity,hasPageAccess };
};